"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _reactI18next = require("react-i18next");
var R = _interopRequireWildcard(require("ramda"));
var _formik = require("formik");
var _fn = require("@otpusk/apisearch-toolbox/dist/queries/fn");
var _reactDeviceDetect = require("react-device-detect");
var _Select = _interopRequireDefault(require("../../../ui/Select"));
var _Label = _interopRequireDefault(require("../../../ui/Label"));
var _styles = _interopRequireDefault(require("./styles"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
var NIGHTS_MAX = 60;
var NIGHTS_MAX_RANGE = 4;
var NIGHTS = R.map(function (value) {
  return {
    content: value,
    value: value
  };
}, R.range(1, R.inc(NIGHTS_MAX)));
var getNightsTo = function getNightsTo(from) {
  return R.call(R.pipe(R.filter(function (_ref) {
    var value = _ref.value;
    return value >= from;
  }), R.take(R.inc(NIGHTS_MAX_RANGE))), NIGHTS);
};
var DurationControl = function DurationControl() {
  var _useTranslation = (0, _reactI18next.useTranslation)('SEARCH_FORM'),
    t = _useTranslation.t;
  var control = /*#__PURE__*/_react.default.createElement(_formik.FastField, {
    name: _fn.QUERY_PARAMS.DURATION,
    render: function render(_ref2) {
      var field = _ref2.field,
        form = _ref2.form;
      return /*#__PURE__*/_react.default.createElement("div", {
        className: _styles.default.selects
      }, /*#__PURE__*/_react.default.createElement(_Select.default, {
        hasError: !field.value.from,
        items: NIGHTS,
        label: _reactDeviceDetect.isMobileOnly ? t('DURATION_CONTROL_LABEL') : undefined,
        value: field.value.from,
        onChange: function onChange(from) {
          return form.setFieldValue(field.name, {
            from: from,
            to: from > field.value.to ? from : Math.min(field.value.to, from + NIGHTS_MAX_RANGE, NIGHTS_MAX)
          });
        }
      }), /*#__PURE__*/_react.default.createElement(_Select.default, {
        error: !field.value.to,
        items: getNightsTo(field.value.from),
        label: _reactDeviceDetect.isMobileOnly ? t('DURATION_CONTROL_LABEL') : undefined,
        value: field.value.to,
        onChange: function onChange(to) {
          return form.setFieldValue(_fn.QUERY_PARAMS.DURATION, R.mergeAll([field.value, {
            to: to
          }]));
        }
      }));
    }
  });
  return _reactDeviceDetect.isMobileOnly ? control : /*#__PURE__*/_react.default.createElement(_Label.default, {
    clickable: false,
    text: t('DURATION_CONTROL_LABEL')
  }, control);
};
var _default = exports.default = DurationControl;